export const FAQ = 'https://www.fomoalert.io/faq';
export const PRIVACY_POLICY = 'https://www.fomoalert.io/legal/privacy';
export const TERMS_AND_CONDITIONS = 'https://www.fomoalert.io/legal/tnc';
export const CONTACT_US = 'mailto:support@fomoalert.io';
export const TWITTER = 'https://twitter.com/fomoalert_io';
